"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _AnnotationRenderer2 = _interopRequireDefault(require("../AnnotationRenderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var LINE_WIDTH_MARKER = 20;
var LINE_WIDTH_OTHER = 8;
var RGB = 255;

var AnnotationRendererV2 = /*#__PURE__*/function (_AnnotationRenderer) {
  _inherits(AnnotationRendererV2, _AnnotationRenderer);

  var _super = _createSuper(AnnotationRendererV2);

  function AnnotationRendererV2() {
    _classCallCheck(this, AnnotationRendererV2);

    return _super.apply(this, arguments);
  }

  _createClass(AnnotationRendererV2, [{
    key: "render",
    value: function render() {
      var context = this.context;
      var width = this.width;
      var height = this.height;
      var annotations = this.annotations;
      this.clear();
      context.lineCap = 'round';
      annotations.forEach(function (annotation) {
        if (annotation.points.length > 1) {
          renderPoints(annotation);
        }
      });

      function renderPoints(annotation) {
        var points = annotation.points;
        var pointCount = points.length;
        var point = points[0];
        var x = point[0] * width;
        var y = point[1] * height;
        context.beginPath();
        context.moveTo(x, y);

        for (var i = 1; i < pointCount; i++) {
          point = points[i];
          x = point[0] * width;
          y = point[1] * height;
          context.lineTo(x, y);
        }

        if (annotation.type === 'marker') {
          context.lineWidth = Math.round(LINE_WIDTH_MARKER / 750 * width);
        } else {
          context.lineWidth = Math.round(LINE_WIDTH_OTHER / 750 * width);
        }

        var color = [annotation.strokeColor.r, annotation.strokeColor.g, annotation.strokeColor.b, annotation.strokeColor.a / RGB].join(',');
        context.strokeStyle = "rgba(".concat(color, "})");
        context.stroke();
      }
    }
  }]);

  return AnnotationRendererV2;
}(_AnnotationRenderer2["default"]);

var _default = AnnotationRendererV2;
exports["default"] = _default;